module.exports = __webpack_public_path__ + "img/4840d48.jpg";